import { PayoutStatus } from "@gen/app-query";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";

import { Select2ApplyBar, Select2MenuItem } from "~/components/select2";
import {
  payoutStatusColors,
  payoutStatusLabels,
} from "~/features/payout_details/payoutData";

const payoutStatuses = Object.values(PayoutStatus);

export interface PayoutStatusPopoverProps {
  initialValue?: PayoutStatus;
  onApply: (status: PayoutStatus | undefined) => void;
  onClose: () => void;
}

// The Core API filters payouts by a single status, so unlike the transaction
// status filter only one status can be selected.
export function PayoutStatusPopover({
  initialValue,
  onApply,
  onClose,
}: PayoutStatusPopoverProps) {
  const theme = useTheme();
  const [value, setValue] = useState(initialValue);
  const apply = () => {
    onApply(value);
    onClose();
  };
  return (
    <Stack>
      <Stack>
        {payoutStatuses.map((status) => (
          <Select2MenuItem
            key={status}
            label={payoutStatusLabels[status]}
            dotColor={theme.palette[payoutStatusColors[status]].main}
            selected={status === value}
            onClick={() => setValue(status === value ? undefined : status)}
          />
        ))}
      </Stack>
      <Select2ApplyBar onApply={apply} />
    </Stack>
  );
}
